import styled from 'styled-components'
import { ReactComponent as SharingIcon } from '@sketch/icons/link-sharing-24'

export const Icon = styled(SharingIcon).attrs({
  width: '24px',
  height: '24px',
  flex: 'none',
})``
